import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from "components/ProtectedRoute";
import AccessLinkGate from "components/AccessLinkGate";
import LoginScreen from "./pages/login-screen";
import ItsmDashboard from "./pages/itsm-dashboard";

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary>
          <ScrollToTop />
          {/* Invite / recovery links from provision-client.ts: confirmed with a click before
              any session from the URL is adopted (see components/AccessLinkGate). */}
          <AccessLinkGate>
            <RouterRoutes>
              <Route path="/login-screen" element={<LoginScreen />} />
              <Route path="/login" element={<LoginScreen />} />
              {/* All other paths render the dashboard (protected). Deep-link paths like
                  /companies/icc/users load it directly; the SPA reads the path and restores. */}
              <Route path="/*" element={<ProtectedRoute><ItsmDashboard /></ProtectedRoute>} />
            </RouterRoutes>
          </AccessLinkGate>
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
